import React, { useEffect, useState } from "react";
import { Grid, withStyles } from "@material-ui/core";
import FechamentoConsumoCabecalho from "./fechamentoConsumoCabecalho";
import FechamentoConsumoCard from "./fechamentoConsumoCard";
import FechamentoConsumoConteudoAppBar from "./fechamentoConsumoConteudoAppBar";
import {
  filtraConsumosPorFormulas,
  listarConsumos,
  DATA_MINIMA,
  DATA_INICIO,
  DATA_TERMINO,
  FAIXA_ACEITE,
} from "../fechamentoConsumoUtils";
import { FakeList } from "../../shared/components";
import FechamentoConsumoFeedback from "./fechamentoConsumoFeedback";
import { retornaDiferencaDatas, objetoPreenchido } from "../../shared/utils";
import moment from "moment";
import FechamentoConsumoLegenda from "./fechamentoConsumoLegenda";
import SelectedFarmContainer from "features/shared/crossCuttingComponents/selectedFarm/selectedFarmContainer";

export async function aplicarFiltrosHelper({
  dataInicio,
  dataFim,
  formulaSelecionada,
  retirosSelecionados,
  obtemFechamentoConsumo,
  setDataInicio,
  setDataFim,
  setFormulaSelecionada,
  setFormulasSelecionadas,
  setRetirosSelecionados,
}) {
  setDataInicio(dataInicio);
  setDataFim(dataFim);
  setFormulaSelecionada({ NomeFormula: "Todas" });
  setFormulasSelecionadas([{ NomeFormula: "Todas" }]);
  setRetirosSelecionados([{ Nome: "Todos" }]);

  await obtemFechamentoConsumo({
    dataInicio: moment(dataInicio).format(),
    dataFim: moment(dataFim).format(),
    formulaSelecionada,
    retirosSelecionados,
  });
}

export const FechamentoConsumoPage = (props) => {
  const {
    listarRetiros,
    fazendaSelecionada,
    obtemFechamentoConsumo,
    formulas,
    classes,
    chamadaConcluida,
    consumos,
    retiros,
    exibirFechamentoConsumo100kgPv,
  } = props;

  const [formulaSelecionada, setFormulaSelecionada] = useState({
    NomeFormula: "Todas",
  });
  const [formulasSelecionadas, setFormulasSelecionadas] = useState([
    { NomeFormula: "Todas" },
  ]);
  const [dataInicio, setDataInicio] = useState(DATA_INICIO);
  const [dataFim, setDataFim] = useState(DATA_TERMINO);
  const [retirosSelecionados, setRetirosSelecionados] = useState([
    { Nome: "Todos" },
  ]);
  const [newValorInicial, setNewValorInicial] = useState([]);

  useEffect(() => {
    const fetchRetiros = async () => {
      await listarRetiros(fazendaSelecionada.IdFazenda);
    };
    fetchRetiros();
  }, [fazendaSelecionada]);

  useEffect(() => {
    if (formulas && formulas.length > 0 && newValorInicial.length <= 1) {
      const valoresIniciais = formulas.map((f) => ({
        label: f.NomeFormula,
        value: f.IdFormula,
      }));
      setNewValorInicial(valoresIniciais);
    }
  }, [formulas]);

  const aplicarFiltros = async (
    dataInicio,
    dataFim,
    formulaSelecionada,
    retirosSelecionados
  ) => {
    await aplicarFiltrosHelper({
      dataInicio,
      dataFim,
      formulaSelecionada,
      retirosSelecionados,
      obtemFechamentoConsumo,
      setDataInicio,
      setDataFim,
      setFormulaSelecionada,
      setFormulasSelecionadas,
      setRetirosSelecionados,
    });
  };

  const corpoFechamentoConsumo = (fazenda) => {
    const fazendaPreenchida = objetoPreenchido(fazenda);
    let consumosFormulas;

    if (
      formulasSelecionadas.length <= 1 &&
      formulasSelecionadas.some((f) => f.NomeFormula === "Todas")
    ) {
      consumosFormulas = filtraConsumosPorFormulas(
        consumos,
        "NomeFormula",
        formulaSelecionada.NomeFormula
      );
    } else {
      consumosFormulas = consumos.filter((consumo) =>
        formulasSelecionadas.some(
          (formula) =>
            String(formula.NomeFormula).toUpperCase() ===
            String(consumo.NomeFormula).toUpperCase()
        )
      );
    }

    const diferencaDatas = retornaDiferencaDatas(dataInicio, dataFim) + 1;

    if (
      fazendaPreenchida &&
      listarConsumos(chamadaConcluida, consumosFormulas)
    ) {
      return (
        <Grid
          container
          justify="flex-start"
          direction="row"
          className={classes.cardList}
        >
          <FechamentoConsumoLegenda />
          <FakeList
            listarItens={chamadaConcluida}
            itensListar={consumosFormulas}
            numeroItensFake={3}
            renderItem={(consumoFormula, idx) => (
              <FechamentoConsumoCard
                data-testid="FechamentoConsumoCard"
                key={`fechamentoConsumo-${idx}`}
                dadosCarregados={chamadaConcluida}
                consumoFormula={{
                  ...consumoFormula,
                  PeriodoBuscado: diferencaDatas,
                }}
                index={idx}
                faixaAceite={FAIXA_ACEITE}
                exibirFechamentoConsumo100kgPv={exibirFechamentoConsumo100kgPv}
              />
            )}
          />
        </Grid>
      );
    }

    return <FechamentoConsumoFeedback />;
  };

  const ConteudoPagina = () => {
    const desabilitaControles = !chamadaConcluida;

    useEffect(() => {
      if (formulas && formulas.length > 0 && newValorInicial.length <= 1) {
        const valoresIniciais = formulas.map((f) => ({
          label: f.NomeFormula,
          value: f.IdFormula,
        }));
        setNewValorInicial(valoresIniciais);
      }
    }, [formulas]);

    const filtroRetiro = retiros.map((v) => ({
      label: v.Nome,
      value: v.IdRetiro,
    }));

    return (
      <Grid
        container
        direction="column"
        className={classes.containerPage}
        alignItems="center"
      >
        <Grid container item direction="column" className={classes.content}>
          <React.Fragment>
            <Grid container item>
              <FechamentoConsumoCabecalho
                formulaSelecionada={formulaSelecionada}
                desabilitaControles={desabilitaControles}
                aplicarFiltros={aplicarFiltros}
                dataInicio={dataInicio}
                dataFim={dataFim}
                minDate={DATA_MINIMA}
                maxDate={DATA_TERMINO}
                selectFormula={setFormulaSelecionada}
                formulas={formulas}
                filtroRetiro={filtroRetiro}
                retiros={retiros}
                retirosSelecionados={retirosSelecionados}
                valorInicial={newValorInicial}
                setFormulasSelecionadas={setFormulasSelecionadas}
                setRetirosSelecionados={setRetirosSelecionados}
              />
            </Grid>
          </React.Fragment>
        </Grid>
        <SelectedFarmContainer
          render={(fazenda) => corpoFechamentoConsumo(fazenda)}
        />
      </Grid>
    );
  };

  return (
    <>
      <FechamentoConsumoConteudoAppBar />
      {ConteudoPagina()}
    </>
  );
};

const styles = (theme) => {
  return {
    containerPage: {
      backgroundColor: theme.palette.white.main,
      paddingTop: 30,
    },
    content: {
      backgroundColor: theme.palette.white.main,
      width: "90%",
      height: "auto",
      padding: "5px 0",
    },
    cardList: {
      paddingTop: 20,
      paddingLeft: "5%",
      paddingRight: "5%",
      backgroundColor: "#f8f8f8",
      "&:hover": { overflowY: "auto" },
    },
  };
};

export default withStyles(styles)(FechamentoConsumoPage);
